var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownloadBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58269 10.3501L10.3045 14.0719M10.3045 14.0719L14.0263 10.3501M10.3045 14.0719V5.51173C10.3045 4.21775 10.3045 3.57076 9.79225 2.84637C9.45191 2.36507 8.47204 1.77103 7.8879 1.69189C7.00873 1.57278 6.67487 1.74694 6.00714 2.09526C3.03148 3.64752 1 6.76155 1 10.3501C1 15.4888 5.16576 19.6545 10.3045 19.6545C15.4432 19.6545 19.609 15.4888 19.609 10.3501C19.609 6.90609 17.7378 3.89914 14.9567 2.29036",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownloadBlanco);
export default __webpack_public_path__ + "static/media/circle-download-blanco.98ac76825ffbd126f19f660ffb642aa7.svg";
export { ForwardRef as ReactComponent };